import { render } from "./ThreeD.vue?vue&type=template&id=43ba07b8"
import script from "./ThreeD.vue?vue&type=script&lang=js"
export * from "./ThreeD.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__